import PropTypes from 'prop-types';
import './CartItemsMobileButton.css';
import { FaArrowUp } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { setCartMobileOpen, setItemIsCompleted } from 'features/cart/cartSlice';

const CartItemsMobileButton = ({ hasCartExtras, extraClass }) => {
    const dispatch = useDispatch();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const isCartMobileOpen = useSelector(
        (state) => state.cart?.isCartMobileOpen
    );
    const hasExtrasForItem = useSelector((state) => state.cart?.hasExtras);
    const items = useSelector((state) => state.cart?.cartItems);
    const firstIncompleteIndex = items.findIndex((item) => !item.isCompleted);
    const currentStep = useSelector((state) => state.cart?.currentStep);
    const item = items[firstIncompleteIndex];
    const hasExtra = item?.extras && item?.extras.length > 0;
    const onClick = (open) => {
        dispatch(setCartMobileOpen(open));
    };
    const onClickContinue = async () => {
        dispatch(
            setItemIsCompleted({
                rateID: item.rateID,
                roomTypeID: item.roomTypeID,
            })
        );
        // }
    };
    return (
        <div className="ab-cart-mobile-items-wrapper">
            <div
                className={`ab-cart-mobile-items ${
                    currentStep === 2 && 'ab-cart-mobile-items-bottom'
                }`}
                onClick={() => onClick(!isCartMobileOpen)}
            >
                <div>{Lang?.yourStaySummary}</div>
                <div>
                    <FaArrowUp />
                </div>
            </div>
            {currentStep === 1 && (
                <div className={`ab-cart-mobile-items-continue`}>
                    <div className="" onClick={() => onClickContinue()}>
                        {!hasExtrasForItem
                            ? Lang?.continueWithoutExtras
                            : hasExtra
                            ? Lang?.continueTxt
                            : Lang?.continueWithoutExtras}
                    </div>
                </div>
            )}
        </div>
    );
};

CartItemsMobileButton.propTypes = {
    hasCartExtras: PropTypes.bool,
    extraClass: PropTypes.string,
};

export default CartItemsMobileButton;
